// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wi9R","fullView":"styles_fullView__2lXj2"};